import SplitType from "split-type";

interface SplitTextProps {
    target: HTMLElement;
    types?: string[];
    lineClass?: string;
    wordClass?: string;
}

declare global {
    interface Window {
        splitText: { target: HTMLElement; split: any }[];
    }
}

declare class SplitType {
    lines?: HTMLElement[];
    words?: HTMLElement[];
    revert: () => void;
    split: (params: any) => void;
    constructor(target: HTMLElement, params: any);
}

export class _splitText {
    target: HTMLElement;
    split: SplitType | null;
    params: {
        types: string[];
        lineClass: string;
        wordClass: string;
    };
    width: number;

    constructor(props: SplitTextProps) {
        this.target = props.target;
        this.split = null;

        this.params = {
            types: props.types ?? ["lines", "words"],
            lineClass: props.lineClass ?? "line-parent",
            wordClass: props.wordClass ?? "word",
        };

        this.width = 0;

        this.init();
    }

    init() {
        if (!window.splitText) window.splitText = [];

        const _existing = window.splitText.find((item) => item.target === this.target);
        if (_existing) {
            _existing.split.revert();
            window.splitText = window.splitText.filter((item) => item.target !== this.target);
        }

        window.splitText.push(this);

        this.split = new SplitType(this.target, this.params);

        let _resizeTimer: ReturnType<typeof setTimeout> | null = null;
        window.addEventListener("resize", () => {
            this.update();

            if (_resizeTimer) clearTimeout(_resizeTimer);
            _resizeTimer = setTimeout(() => {
                this.update();
            }, 300);
        });
        this.update();
    }

    update() {
        // if (this.target.offsetWidth <= 0) return;
        if (!this.split) return;

        if (this.width === this.target.offsetWidth) return;
        this.width = this.target.offsetWidth;

        this.split.revert();
        this.split.split(this.params);

        this.split.lines?.forEach((line, index) => {
            line.setAttribute("style", `--index:${index}`);
            line.classList.add("relative", "overflow-hidden");
            if (index === this.split.lines?.length - 1) line.style.marginBottom = "0px";
        });

        this.split.words?.forEach((word, index) => {
            word.setAttribute("style", `display:inline-block;--index:${index}`);

            if (/\p{Extended_Pictographic}/u.test(word.innerHTML)) {
                word.classList.add("emoji");
            }
        });
    }
}
